const HelpData = [
    {
        en_type: 'PDF content',
        kn_type: 'PDF ವಿಷಯಗಳು',
        en_download: ['Adobe Acrobat Reader'],
        kn_download: ['Adobe ಆಕ್ರೋಬ್ಯಾಟ್ ರೀಡರ್']
    },
    {
        en_type: 'Word files',
        kn_type: 'ವರ್ಡ್ ಫೈಲ್ಗಳು',
        en_download: ['Word Viewer', 'Microsoft Office Compatibility Pack for Word (for 2007 version)'],
        kn_download: ['ವರ್ಡ್ ವ್ಯೂಯರ್', 'Microsoft ಆಫೀಸ್ ಹೊಂದಾಣ ಹೊಂದಾಣ ಪ್ಯಾಕ್ ಫರ್ ವರ್ಡ್ (2007 ಆವೃತ್ತಿಗಾಗಿ)']
    },
    {
        en_type: 'Excel files',
        kn_type: 'ಎಕ್ಸೆಲ್ ಫೈಲ್ಗಳು',
        en_download: ['Excel Viewer', 'Microsoft Office Compatibility Pack for Excel (for 2007 version)'],
        kn_download: ['ಎಕ್ಸೆಲ್ ವ್ಯೂಯರ್', 'Microsoft ಆಫೀಸ್ ಹೊಂದಾಣ ಹೊಂದಾಣ ಪ್ಯಾಕ್ ಫರ್ ಎಕ್ಸೆಲ್ (2007 ಆವೃತ್ತಿಗಾಗಿ)']
    },
    {
        en_type: 'PowerPoint presentations',
        kn_type: 'ಪವರ್‌ಪಾಯಿಂಟ್ ಪ್ರದರ್ಶನಗಳು',
        en_download: ['PowerPoint Viewer', 'Microsoft Office Compatibility Pack for PowerPoint (for 2007 version)'],
        kn_download: ['ಪವರ್‌ಪಾಯಿಂಟ್ ವ್ಯೂಯರ್', 'Microsoft ಆಫೀಸ್ ಹೊಂದಾಣ ಹೊಂದಾಣ ಪ್ಯಾಕ್ ಫರ್ ಪವರ್‌ಪಾಯಿಂಟ್ (2007 ಆವೃತ್ತಿಗಾಗಿ)']
    },
    {
        en_type: 'Audio Files',
        kn_type: 'ಆಡಿಯೋ ಫೈಲ್ಗಳು',
        en_download: ['Adobe Acrobat Reader'],
        kn_download: ['Adobe ಆಕ್ರೋಬ್ಯಾಟ್ ರೀಡರ್']
    }
];

export default HelpData;
